export const LOAD_BANCOS = 'LOAD_BANCOS';
export const SET_BANCOS = 'SET_BANCOS';

export const SAVE_BANCO = 'SAVE_BANCO';
export const SAVED_BANCO = 'SAVED_BANCO';

export const loadBancos = () => ({
    type: LOAD_BANCOS,
});

export const setBancos = (bancos) => ({
    type: SET_BANCOS,
    bancos,
});

export const saveBanco = (banco) => ({
    type: SAVE_BANCO,
    banco,
});

export const savedBanco = (banco) => ({
    type: SAVED_BANCO,
    banco,
});

const initialState = {
    bancos: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
    case SAVED_BANCO: {
        const { banco } = action;
        const index = state.bancos.findIndex((item) => item.id === banco.id);
        if (index === -1) {
            return {
                ...state,
                bancos: state.bancos.concat(banco),
            };
        }
        const updated = state.bancos
            .slice(0, index)
            .concat([banco])
            .concat(state.bancos.slice(index + 1));
        return {
            ...state,
            bancos: updated,
        };
    }
    case SET_BANCOS: {
        const { bancos } = action;
        return {
            ...state,
            bancos,
        };
    }
    default:
        return state;
    }
};
